module.exports = __webpack_public_path__ + "static/107_001-64cbe4f6939cbba6f310c366e1935fb3.jpg";